// extracted by mini-css-extract-plugin
export default {"icon":"iRp4VCI86U6QqpM_jaLC"};